/**
 * SEO "Stats": mobile swipe track with active dot tracking.
 */
document.addEventListener('DOMContentLoaded', function () {
    var track = document.getElementById('seoStatsGridTrack');
    var dotsWrap = document.getElementById('seoStatsDots');
    if (!track || !dotsWrap) return;

    var items = track.querySelectorAll('.seo-stats__item');
    var dots = dotsWrap.querySelectorAll('.seo-stats__dot');
    if (!items.length || !dots.length) return;

    function updateActive() {
        if (window.innerWidth > 767) return;
        var trackRect = track.getBoundingClientRect();
        var center = trackRect.left + track.offsetWidth / 2;
        var closestIdx = 0;
        var minDiff = Infinity;

        items.forEach(function (item, idx) {
            var rect = item.getBoundingClientRect();
            var diff = Math.abs(center - (rect.left + rect.width / 2));
            if (diff < minDiff) {
                minDiff = diff;
                closestIdx = idx;
            }
        });

        dots.forEach(function (dot, idx) {
            dot.classList.toggle('is-active', idx === closestIdx);
        });
    }

    track.addEventListener('scroll', function () {
        requestAnimationFrame(updateActive);
    }, { passive: true });

    dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
            var item = items[parseInt(this.getAttribute('data-dot-index'), 10)];
            if (item) item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
    });

    window.addEventListener('resize', updateActive);
});
